import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { BackgroundMusic } from '../components/BackgroundMusic';
import { DashboardLogin } from '../components/dashboard/DashboardLogin';
import { DashboardPortal } from '../components/dashboard/DashboardPortal';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { useAuth } from '../contexts/AuthContext';
import { presentationAccountProfile, presentationCharacters, presentationCoinBalance, presentationCoinPackages, presentationTransactions } from '../data/presentationData';
import type { DashboardIntent } from '../data/contracts';
const dashboardIntents: DashboardIntent[] = ['overview', 'buy', 'withdraw', 'unstuck', 'settings'];
export function DashboardPage() {
  const {
    user,
    isAuthenticated,
    clearAuthenticatedUser
  } = useAuth();
  const [searchParams] = useSearchParams();
  const requestedIntent = searchParams.get('intent');
  const initialIntent = dashboardIntents.includes(requestedIntent as DashboardIntent) ? requestedIntent as DashboardIntent : 'overview';
  const account = {
    ...presentationAccountProfile,
    username: user?.username ?? presentationAccountProfile.username,
    email: user?.email ?? presentationAccountProfile.email
  };
  return <div className="min-h-screen bg-darkBlue text-white font-sans selection:bg-gold/30 selection:text-white flex flex-col" data-id="element-660">
      <BackgroundMusic data-id="element-661" />
      <Navigation data-id="element-662" />

      {isAuthenticated ? <DashboardPortal account={account} balance={presentationCoinBalance} characters={presentationCharacters} coinPackages={presentationCoinPackages} transactions={presentationTransactions} initialIntent={initialIntent} onLogout={clearAuthenticatedUser} data-id="element-663" /> : <DashboardLogin data-id="element-664" />}

      <Footer data-id="element-665" />
    </div>;
}